import { dsClass } from '../../../common/constants/dsClasses.js';
import { t } from '../../../common/i18n/index.js';
import type { AuthenticatedUser } from '../../../public/site/authState';

import './PunchoutUserInfo.scss';

type PunchoutUserInfoProps = {
  user: AuthenticatedUser;
  className?: string;
};

export const PunchoutUserInfo = ({ user, className }: PunchoutUserInfoProps) => (
  <div className={`of-punchout-checkout-user-info ${className || ''}`}>
    <h2 className={`of-sub-header ${dsClass.H2}`}>{t.HS3T('Customer details')}</h2>
    <div className="of-user-details">
      <div>{user.companyName}</div>
      <div>{`${user.firstName} ${user.lastName}`}</div>
      <div>{user.email}</div>
    </div>
  </div>
);
